import { render, staticRenderFns } from "./SharedHostingComponent.vue?vue&type=template&id=215b7e65&scoped=true&"
import script from "./SharedHostingComponent.vue?vue&type=script&lang=js&"
export * from "./SharedHostingComponent.vue?vue&type=script&lang=js&"
import style0 from "./SharedHostingComponent.vue?vue&type=style&index=0&id=215b7e65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b7e65",
  null
  
)

export default component.exports